import { styled } from "styled-components";

import { colorCSS } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const VideoRatio16By9 = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("N900", 0.25)}`)}
    ${redundantCssFromKebab("padding", "56.25% 0 0 0")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("overflow", "hidden")}
`;

export const ResponsiveVideoWrapper = styled.div`
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("left", "0")}
    ${redundantCssFromKebab("position", "absolute")}
    ${redundantCssFromKebab("top", "0")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const ResponsiveVideoFrame = styled.iframe`
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("left", "0")}
    ${redundantCssFromKebab("position", "absolute")}
    ${redundantCssFromKebab("top", "0")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const VideoEmbed = styled.div`
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("height", "100%")}
`;
